'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFilteredChangeInfo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _keyPaths = require('../constants/keyPaths');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _immutable = require('immutable');

var _filterTypes = require('../constants/filterTypes');

var _FilteredChangeInfo = require('../records/FilteredChangeInfo');

var _FilteredChangeInfo2 = _interopRequireDefault(_FilteredChangeInfo);

var _validFilterChangeTypeInvariant = require('../invariants/validFilterChangeTypeInvariant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildFilteredChangeInfo = exports.buildFilteredChangeInfo = function buildFilteredChangeInfo(attrs) {
  var jsAttrs = attrs;

  if (_immutable.Iterable.isIterable(attrs)) {
    jsAttrs = attrs.toJS();
  }
  var type = (0, _get2.default)(_keyPaths.TYPE, attrs);
  (0, _validFilterChangeTypeInvariant.validFilterChangeTypeInvariant)(type);

  switch (type) {
    case _filterTypes.SPAM:
    case _filterTypes.BLOCK:
      return new _FilteredChangeInfo2.default(_extends({}, jsAttrs));
    default:
      return null;
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/filtered-change-message-metadata/operators/buildFilteredChangeInfo.js
// module id = 723
// module chunks = 2 3